import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper/core';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-swiper-quote',
    templateUrl: './swiper-quote.component.html',
    styleUrls: ['./swiper-quote.component.scss']
})
export class SwiperQuoteComponent implements OnInit {

    quotes: any = [];
    isBeginWhy: boolean = true;
    isEndWhy: boolean = false;
    whySwiperInstance: any;

    constructor(private api: ApiService, private cd: ChangeDetectorRef) { }

    ngOnInit(): void {

        this.fetchQuotes();

    }

    /**
     * Fetches customer quotes
     */
    async fetchQuotes() {

        await this.api.fetch_quotes()
            .subscribe(res => {
                this.quotes = res.data.items;
                this.quotes.forEach((item, index) => {
                    this.quotes[index].quote = JSON.parse(item.quote); 
                });
                this.cd.detectChanges();
            }, (err) => {

            });

    }

    /**
     * When 'Why people love IBTC' swiper is ready then run the update so that the slide size is correct
     * @param swiper 
     */
    onWhySwiper(swiper) {

        this.whySwiperInstance = swiper;

        setTimeout(() => {
            //  swiper.update();
        }, 1500);

    }

    /**
     * Using slidechange to disable / enable the next and previous buttons
     */
    onWhySlideChange() {

        this.isBeginWhy = this.whySwiperInstance.isBeginning;
        this.isEndWhy = this.whySwiperInstance.isEnd;

    }

    /**
     * Slides to the next image
     */
    gotoWhyNext() {

        this.whySwiperInstance.slideNext();

    }

    /**
     * Slides to the previous image
     */
    gotoWhyPrevious() {

        this.whySwiperInstance.slidePrev();

    }

}
